module.exports = __webpack_public_path__ + "img/l2.49001d00.jpg";